/**
 * Requests Page Tour Configuration
 * Guided tour for feature request submission and tracking
 */

export const REQUESTS_TOUR_STEPS = [
  {
    id: 'welcome',
    title: 'Submit & Track Feature Requests 💡',
    description: 'Request new AI tools or enhancements and track their progress through development!',
    position: 'center'
  },
  {
    id: 'tabs',
    title: 'My Requests vs Admin Queue',
    description: 'View your personal requests here, or see all pending requests if you are an admin.',
    element: '[data-tour="requests-tabs"]',
    position: 'bottom',
    spotlight: true
  },
  {
    id: 'submit-button',
    title: 'Submit a New Request',
    description: 'Click here to start the 4-step submission wizard. Choose from Ideation, Active Development, or Enhancement requests.',
    element: '[data-tour="requests-submit"]',
    position: 'bottom',
    spotlight: true
  },
  {
    id: 'request-card',
    title: 'Track Request Progress',
    description: 'Each request card shows its current status and a visual workflow indicator. Click to see full details and discussion.',
    element: '[data-tour="requests-list"]',
    position: 'right',
    spotlight: true
  }
];
